// removed by extract-text-webpack-plugin
module.exports = {"hidden":"UyxJm","visuallyhidden":"Q63eD","hide-text":"ywu5_","center":"_3k5_C","noprint":"ayphn","videoRatio":"_13S6V","square":"_51epf","audio":"_1hyVa","root":"_2n018"};


/*****************
 ** WEBPACK FOOTER
 ** ./themes/ui-inline-video/styles/default.scss
 ** module id = 1008
 ** module chunks = 2
 **/